import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { IHotCellAngularRenderedCellComponent } from "~app/common/components/hot-doc/hotdoc/hot-cell-angular-renderer.service";
import { ForsorjningskallaAggregat, ForsorjningskallaTyp } from "~app/common/models/forsorjningskalla";
import { CommandService } from "~app/common/services/cqs/command.service";
import { SetForsorjningskallaManuellPaArbetsorderCommand } from "~app/features/forsaljning/kundorder/commands/SetForsorjningskallaManuellPaArbetsorderCommand";
import { KundorderradAggregat } from "../kor-hot.model";

@Component({
    selector: "rask-forsorjningskalla-cell",
    templateUrl: "./forsorjningskalla-cell.component.html",
    styleUrls: ["./forsorjningskalla-cell.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterLink,
        CheckboxComponent,
        FormsModule
    ]
})
export class ForsorjningskallaCellComponent implements IHotCellAngularRenderedCellComponent {
    canEdit: boolean;
    forsorjningsKallaAggregat: ForsorjningskallaAggregat;
    forsorjningskallaTyp = ForsorjningskallaTyp;
    kundorderradAggregat: KundorderradAggregat;

    private readonly commandService = inject(CommandService);

    applyData = (forsorjningsKalla: ForsorjningskallaAggregat, kundorderrad: KundorderradAggregat, canEdit: boolean) => {
        this.forsorjningsKallaAggregat = forsorjningsKalla;
        this.kundorderradAggregat = kundorderrad;
        this.canEdit = canEdit;
    };

    getShortNamn(): string {
        return this.forsorjningsKallaAggregat.namn.substring(0, 30).replace(/(\r\n|\n|\r)/gm, "");
    }

    updateCommand($event: boolean): void {
        const checked = $event;

        const command = new SetForsorjningskallaManuellPaArbetsorderCommand(this.kundorderradAggregat.kundorderradId, this.forsorjningsKallaAggregat.id);
        command.manuellPaArbetsorder = checked;
        const existingCommand = this.commandService.transactionCommandQueue
            .filter(x => x.$type === SetForsorjningskallaManuellPaArbetsorderCommand.$type)
            .find((t: SetForsorjningskallaManuellPaArbetsorderCommand) => t.primaryKey.Id === command.primaryKey.Id && t.primaryKey.poid === command.primaryKey.poid);

        if (existingCommand) {
            this.commandService.removeCommand(existingCommand);
        }

        this.commandService.addTransactionCommand(command);
    }
}
